import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from './api';
import "../styles/login.css";
import logo from "../images/logo.png";
import { FaChevronLeft, FaEye, FaEyeSlash } from 'react-icons/fa';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); 
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // توابع کمکی
  const convertPersianToEnglishNumbers = (text) => {
    const persianToEnglish = {
      '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
      '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9'
    };
    return text.replace(/[۰-۹]/g, (match) => persianToEnglish[match]);
  };

  const containsPersianCharacters = (text) => {
    const persianRegex = /[\u0600-\u06FF]/;
    return persianRegex.test(text);
  };

  // هندلر نام کاربری/شماره تلفن
  const handleUsernameChange = (e) => {
    const value = e.target.value;
    // تبدیل اعداد فارسی به انگلیسی
    setUsername(convertPersianToEnglishNumbers(value));
  };

  // هندلر رمز عبور - با خطا
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    if (containsPersianCharacters(value)) {
      setError('رمز عبور نباید شامل حروف فارسی باشد');
      return;
    }
    setError('');
    setPassword(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!username.trim()) {
      setError("لطفا نام کاربری یا شماره تلفن را وارد کنید.");
      return;
    }
    if (!password.trim()) {
      setError("لطفا رمز عبور را وارد کنید.");
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/pre_student/api/v3/pre_student_login/', {
        username_or_phone_number: username,
        password: password,
      });

      if (response.data?.access && response.data?.refresh) {
        localStorage.setItem('accessToken', response.data.access);
        localStorage.setItem('refreshToken', response.data.refresh);
        navigate('/');
      } else {
        setError('مشکلی در پاسخ سرور پیش آمده است.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'نام کاربری یا رمز عبور اشتباه است.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='d-flex justify-content-center ' style={{ alignItems: "center", height: "100vh" }}>
      <div className="login-body">
        <div className="wrapper">
          <form onSubmit={handleSubmit}>
            <div className="login_box p-lg-5 p-4">
              <div className='logo-container d-flex justify-content-center'>
                <img className='rounded-circle  p-2' src={logo} width={60} height={60} alt="logo" />
              </div>
              <span className='fs-5 d-flex justify-content-center my-4'>مجموعه آموزشی پایتون تیک</span>
              <span className='green d-flex justify-content-center mt-4'>ورود</span>
              <span className='complete-info my-2 d-flex justify-content-center'>
                برای ورود به پنل کاربری اطلاعات زیر را کامل کنید
              </span>

              {/* نمایش خطا */}
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <div className="input_box">
                <input
                  type="text"
                  id="user"
                  className="input-field"
                  value={username}
                  onChange={handleUsernameChange}
                  placeholder='تلفن همراه یا نام کاربری'
                  onPaste={(e) => {
                    const pastedText = e.clipboardData.getData('text');
                    e.preventDefault();
                    setUsername(convertPersianToEnglishNumbers(pastedText));
                  }}
                />
              </div>

              <div className="input_box" style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  id="pass"
                  className="input-field"
                  value={password}
                  onChange={handlePasswordChange}
                  placeholder='رمز عبور'
                  onPaste={(e) => {
                    const pastedText = e.clipboardData.getData('text');
                    if (containsPersianCharacters(pastedText)) {
                      e.preventDefault();
                      setError('رمز عبور نباید شامل حروف فارسی باشد');
                    } else {
                      setPassword(pastedText);
                    }
                  }}
                />
                {/* آیکون چشم */}
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#555",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>

                <a style={{cursor:"pointer"}} onClick={() => navigate("/forgot-password")} className='green forget-pass'>فراموشی رمز عبور</a>
              </div>

              <div className="input_box">
                <button
                  type="submit"
                  className="input-submit"
                  disabled={loading}
                >
                  {loading ? 'در حال ورود...' : ' ورود به پنل'}
                  <FaChevronLeft className='me-2 ' style={{ fontSize: "11px" }} />
                </button>
              </div>
              <div>
                 <div className="text-center mt-2 pt-2" style={{ borderTop: "1px solid #eee" }}>
                  <span style={{ fontSize: "14px", color: "#6c757d" }}>
                    حساب کاربری ندارید؟{" "}
                    <a
                      onClick={() => navigate('/register')}
                      style={{
                        color: "#28a745",
                        textDecoration: "none",
                        fontWeight: "600",
                        cursor: "pointer"
                      }}
                      onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                      onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                    >
                      ثبت‌نام کنید
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;